import React from 'react';

/**
 * Chevron pointing left — used by SectionListingStrip's "previous" arrow.
 * Stroke-only, sized via CSS, color via currentColor.
 */
const IconChevronLeft = props => (
  <svg
    className={props.className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="m10 12-4-4 4-4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconChevronLeft;
